module.exports = __webpack_public_path__ + "img/1531069037.3586a8bb.jpg";